import { render, staticRenderFns } from "./fixed-payments-icon.vue?vue&type=template&id=114b2cb6&scoped=true"
import script from "./fixed-payments-icon.vue?vue&type=script&lang=js"
export * from "./fixed-payments-icon.vue?vue&type=script&lang=js"
import style0 from "./fixed-payments-icon.vue?vue&type=style&index=0&id=114b2cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b2cb6",
  null
  
)

export default component.exports